'use client'
import { useRouter, useSearchParams } from 'next/navigation'

export const useBackNavigation = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const handleBack = () => {
    const redirect = searchParams.get('redirect')
    if (redirect) {
      router.push(redirect)
    } else if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back()
    } else {
      router.push('/')
    }
  }

  return handleBack
}